import { useState, useEffect, useMemo } from 'react'
import { subscribeToAdminPendingRequests } from '../services/firebase/clubs'

interface AdminNotifications {
  creationRequests: number
  deletionRequests: number
  totalPendingCount: number
  isLoading: boolean
}

export const useAdminNotifications = (isWebsiteAdmin: boolean): AdminNotifications => {
  const [counts, setCounts] = useState({
    creationRequests: 0,
    deletionRequests: 0,
    total: 0
  })
  const [isLoading, setIsLoading] = useState(true)

  // Calculate total pending count
  const totalPendingCount = useMemo(() => {
    return counts.total
  }, [counts.total])

  useEffect(() => {
    if (!isWebsiteAdmin) {
      setCounts({ creationRequests: 0, deletionRequests: 0, total: 0 })
      setIsLoading(false)
      return
    }

    setIsLoading(true)

    // Subscribe to real-time updates
    const unsubscribe = subscribeToAdminPendingRequests((newCounts) => {
      setCounts(newCounts)
      setIsLoading(false)
    })

    // Cleanup subscription on unmount or when admin status changes
    return () => {
      unsubscribe()
    }
  }, [isWebsiteAdmin])

  return {
    creationRequests: counts.creationRequests,
    deletionRequests: counts.deletionRequests,
    totalPendingCount,
    isLoading
  }
}